import { FeatureIslandMainWithCategoryWrapper } from "@/components/features/_layouts";

import { QuestionOptionMinimumBuyableNumPerTarget } from "./minimum-buyable-num-per-target";
import { QuestionOptionPrice } from "./price";
import { QuestionOptionSalesType } from "./sales-type";
import { useProductOptionFormModelContext } from "../../context";

import type { StandardOptionCategoriesAndManagerStore } from "../../store/categories";

type Props = {
	salesTypeAndPrice: StandardOptionCategoriesAndManagerStore["salesTypeAndPrice"];
};

export const QuestionOptionSalesTypeAndPrice = ({ salesTypeAndPrice }: Props) => {
	const { useAsSubOption } = useProductOptionFormModelContext().viewModel;
	// サブオプション設定時はオプション料金コンポーネントを非表示
	const isPriceDisabled = useAsSubOption.value;

	return (
		<>
			<FeatureIslandMainWithCategoryWrapper categoryStore={salesTypeAndPrice}>
				<QuestionOptionPrice isPriceDisabled={isPriceDisabled} />
				<QuestionOptionSalesType />
			</FeatureIslandMainWithCategoryWrapper>

			<FeatureIslandMainWithCategoryWrapper categoryStore={salesTypeAndPrice} islandTitle="高度な設定">
				<QuestionOptionMinimumBuyableNumPerTarget />
			</FeatureIslandMainWithCategoryWrapper>
		</>
	);
};

QuestionOptionSalesTypeAndPrice.displayName = "QuestionOptionSalesTypeAndPrice";
